import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import Header from "../common/Header";
import Button from "@p1s/p1s-common-react/Button";
import Banner from "@p1s/p1s-common-react/entities/Banner";

import TextInput from "../../controls/TextInput";
import InputError from "../../controls/InputError";
import LoginHelp from "../common/LoginHelpWidget.jsx";
import CapsLockDetector from "../../utilities/CapsLockDetector";
import UnsupportedBrowserReminderDialog from "./UnsupportedBrowserReminderDialog";
import UrlHelper from "../../utilities/UrlHelper";

import { loadSsoSettingsForSiteId } from "../../actions/OrganizationActions";
import { ssoStartLogin, startLogin } from "../../actions/UserActions";
import { getDownloadBrowsersInfo } from "../../actions/AppActions";
import { getBanners } from "../../actions/BannersActions";

import CookieManager from "../../utilities/CookieManager";
import { isEnterPressed } from "../../utilities/EventsHelper";
import SessionTimeoutAlert from "../../controls/SessionTimeoutAlert";
import MaintenanceBanner from "newApp/components/EmailLogin/MaintenanceBanner";

export class Login extends Component {
    constructor(props) {
        super(props);

        var href = UrlHelper.parseUrl();

        const siteIdFromCookie = CookieManager.getSiteIdForLoginPage();
        let rememberMe = false;
        let siteId = "";
        if (siteIdFromCookie !== undefined) {
            siteId = siteIdFromCookie;
            rememberMe = true;
        }

        this.state = {
            siteId: siteId,
            capslock: false,
            loaded: true,
            userId: "",
            authenticating: false,
            password: "",
            rememberMe: rememberMe,
            product: UrlHelper.getProductNameFromUrl(false),
            returnUrl: UrlHelper.getProperty("returnurl", href.query)
        };

        this.handleRememberSiteCheck = this.handleRememberSiteCheck.bind(this);
        this.handleSiteIdChange = this.handleSiteIdChange.bind(this);
        this.handleSignInClick = this.handleSignInClick.bind(this);
        this.handlePasswordKeyPress = this.handlePasswordKeyPress.bind(this);
        this.onSiteIdChange = this.onSiteIdChange.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onUserIdChange = this.onUserIdChange.bind(this);
        this.handleEnterKey = this.handleEnterKey.bind(this);
    }

    componentDidMount() {
        import("./_styles.scss");

        this.props.getDownloadBrowsersInfo();
        this.props.getBanners();
        const siteIdFromCookie = CookieManager.getSiteIdForLoginPage();
        if (siteIdFromCookie != undefined) {
            this.setState({ siteId: siteIdFromCookie });
            this.props.loadSsoSettingsForSiteId(siteIdFromCookie);
        }
    }

    handlePasswordKeyPress(e) {
        this.setState({ "capslock": CapsLockDetector(e) });
    }

    handleSiteIdChange() {
        this.props.loadSsoSettingsForSiteId(this.state.siteId);
    }

    handleRememberSiteCheck(e) {
        this.setState({ rememberMe: e.target.checked });
    }

    onPasswordChange(e) {
        this.setState({ password: e.target.value });
    }

    onUserIdChange(e) {
        this.setState({ userId: e.target.value });
    }

    handleEnterKey(e) {
        if (isEnterPressed(e)) {
            this.handleSignInClick();
        }
    }

    handleSignInClick() {
        const { product, returnUrl } = this.state;
        this.setState({ authenticating: true });
        this.props.loadSsoSettingsForSiteId(this.state.siteId).finally(() => {
            if (this.props.isSsoEnabled) {
                this.props.ssoStartLogin(this.state.siteId).then(() => {
                    this.setRememberCookie();
                }).catch(() => {
                    this.setState({ authenticating: false });
                });
            } else {
                this.props.login(this.state.siteId, this.state.userId, this.state.password, product, returnUrl).then(() => {
                    this.setRememberCookie();
                }).catch(() => {
                    this.setState({ authenticating: false });
                });
            }
        });
    }

    setRememberCookie() {
        if (this.state.rememberMe) {
            CookieManager.setSiteIdForLoginPage(this.state.siteId);
        } else {
            CookieManager.removeSiteIdForLoginPage();
        }

        if (this.state.siteId) {
            CookieManager.setSsoSiteId(this.state.siteId);
        }
    }

    onSiteIdChange(e) {
        this.setState({ siteId: e.target.value });
    }

    render() {
        if (this.props.redirectTo != null) {
            window.location = this.props.redirectTo;
        }

        var signInButtonTitle = this.props.isSsoEnabled ? "SSO Sign In" : "Sign In";
        var signInButtonClass = classNames("btn btn-primary-action pull-right", { "hidden": this.state.authenticating });
        var userIdDivClass = classNames("login-row", { "hidden": this.props.isSsoEnabled });
        var passwordDivClass = classNames("login-row m-b-0", { "hidden": this.props.isSsoEnabled });
        var signInThrobberClass = classNames("throbberContainer", { "hidden": !this.state.authenticating });

        return (
            <div id="loginpage">
                <Header targetProduct={this.state.product} hideLogout={true} showLoginPageUrls={true}/>

                <UnsupportedBrowserReminderDialog getDownloadBrowsersInfo={this.props.getDownloadBrowsersInfo}
                    browserInfo={this.props.browsers}
                />

                {this.props.maintenanceBanner && this.props.maintenanceBanner.isActive && <div className="banner-placeholder">
                    <div className="col-md-3"/>
                    <div className="col-md-8">
                        <MaintenanceBanner banner={this.props.maintenanceBanner} />
                    </div>
                </div>}

                <div className="row signInRow">
                    <div className="col-md-3">&nbsp;</div>
                    <div className="col-md-8">
                        <h2>Sign In</h2>

                        <SessionTimeoutAlert/>

                        <div className="box">
                            <LoginHelp isSsoEnabled={this.props.isSsoEnabled} targetProduct={this.state.product}/>
                            <div className="siteid-login-row">
                                <div className="formControlTitle" style={{ display: "table-caption" }}>Site ID</div>
                                <TextInput value={this.state.siteId}
                                    onKeyUp={this.handleEnterKey}
                                    onBlur={this.handleSiteIdChange}
                                    onChange={this.onSiteIdChange}
                                    id="siteId"
                                    inputClassName="picker-hollow"
                                    tabIndex={"1"}
                                />

                                <div id="rememberMeGroup" className="checkbox checkbox-primary">
                                    <label>
                                        <input ref="rememberMe"
                                            id="rememberMe"
                                            type="checkbox"
                                            tabIndex="5"
                                            checked={this.state.rememberMe}
                                            onChange={this.handleRememberSiteCheck}
                                        />
                                        <span className="checkbox-material">
                                            <span id="rememberMeCheck" className="check"/>
                                        </span>
                                        <div className="formControlTitle">
                                            <span>Remember Site ID</span>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div className={userIdDivClass}>
                                <div className="formControlTitle">User ID</div>

                                <TextInput value={this.state.userId}
                                    onKeyUp={this.handleEnterKey}
                                    onChange={this.onUserIdChange}
                                    id="userId"
                                    inputClassName="picker-hollow"
                                    tabIndex={"2"}
                                />
                            </div>

                            <div className={passwordDivClass}>

                                <div className="formControlTitle">Password</div>
                                <TextInput value={this.state.password}
                                    onKeyUp={this.handleEnterKey}
                                    onKeyPress={this.handlePasswordKeyPress}
                                    onChange={this.onPasswordChange}
                                    id="password"
                                    inputClassName="picker-hollow"
                                    isPassword={true}
                                    tabIndex={"3"}
                                />
                            </div>
                            <div className="login-row">
                                <InputError label="CAPS Lock Is ON"
                                    visible={this.state.capslock && !this.props.isSsoEnabled}/>

                            </div>
                            <div id="buttonContainer">
                                <Button id="bSignIn"
                                    className={signInButtonClass}
                                    tabIndex="4"
                                    onClick={this.handleSignInClick}>{signInButtonTitle}</Button>
                                <div id="loginThrobberContainer" className={signInThrobberClass}>
                                    <label>Loading</label>
                                    <div/>
                                    {/*do not delete this empty div, it is used in css*/}
                                </div>
                            </div>

                            <div role="alert"
                                style={{ display: this.props.loginFailure ? "block" : "none" }}
                                className="alert alert-danger"><span id="loginErrorMessage"
                                    className="alertSummaryText">Login Failed</span>{this.props.loginFailure}
                            </div>

                        </div>
                    </div>
                    <div className="col-md-1">&nbsp;</div>
                </div>
            </div>
        );
    }
}

Login.defaultProps = {
    getDownloadBrowsersInfo: () => {},
    getBanners: () => {},
    redirectTo: null,
    browsers: []
};

Login.propTypes = {
    loadSsoSettingsForSiteId: PropTypes.func,
    ssoStartLogin: PropTypes.func,
    getDownloadBrowsersInfo: PropTypes.func,
    getBanners: PropTypes.func,
    login: PropTypes.func,
    isSsoEnabled: PropTypes.bool,
    maintenanceBanner: PropTypes.instanceOf(Banner)
};

const mapStateToProps = state => ({
    redirectTo: state.appState.redirectTo,
    loginFailure: state.loginState.loginFailure,
    isSsoEnabled: state.organizationState.isSsoEnabled,
    browsers: state.appState.browsers,
    maintenanceBanner: state.bannersState.maintenanceBanner,
});

const mapDispatchToProps = (dispatch) => {
    return ({
        loadSsoSettingsForSiteId: (siteId) => dispatch(loadSsoSettingsForSiteId(siteId)),
        ssoStartLogin: (siteId) => dispatch(ssoStartLogin(siteId)),
        login: (siteId, userId, password, product, returnUrl) => dispatch(startLogin(siteId, userId, password, product, returnUrl)),
        getDownloadBrowsersInfo: () => dispatch(getDownloadBrowsersInfo()),
        getBanners: () => dispatch(getBanners())
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
